<template>
  <div class="daypart-viewer-container">
    <div>
      <table class="table table-bordered">
        <colgroup>
          <col />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
          <col width="3.75%" />
        </colgroup>
        <thead>
          <tr>
            <th />
            <template v-if="isSmall">
              <th
                v-for="i in [0, 6, 12, 18]"
                :key="i"
                colspan="6"
                style="text-align: left; padding-left: 0.3rem !important">
                <span
                  >{{ days[0].hours[i].compactLabel }} <sub>{{ days[0].hours[i].compactLabelSuffix }}</sub></span
                >
              </th>
            </template>
            <template
              v-for="(hour, hourIndex) in days[0].hours"
              v-else
              :key="hourIndex">
              <th>
                <div class="angled-text-container">
                  <span
                    ><b>{{ hour.compactLabel }}</b>
                    <sub v-if="hour.compactLabelSuffix !== ''"> {{ hour.compactLabelSuffix }}</sub>
                  </span>
                </div>
              </th>
            </template>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="day in days"
            :key="day.label">
            <th>{{ !isAvailableWidthReduced ? day.labelBig : day.label }}</th>
            <td
              v-if="day.index === 1"
              colspan="24"
              rowspan="7"
              style="padding: 0"
              class="canvas-cell">
              <DaypartGrid
                :schedule="weekSchedule"
                :time-interval="'hour'"
                :is-read-only="true" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import { DateTime } from 'luxon';

  import Day from '@/common/models/Day';
  import WeekSchedule from '@/common/models/daypart/WeekSchedule';
  import GlobalEventBus from '@/GlobalEventBus';
  import GlobalEvents from '@/GlobalEvents';

  import DaypartGrid from './daypartEditor/DaypartGrid.vue';

  export default {
    components: {
      DaypartGrid,
    },
    props: {
      daypart: {
        type: String,
      },
      isSmall: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        days: [
          new Day(DateTime.local().startOf('week')),
          new Day(DateTime.local().startOf('week').plus({ days: 1 })),
          new Day(DateTime.local().startOf('week').plus({ days: 2 })),
          new Day(DateTime.local().startOf('week').plus({ days: 3 })),
          new Day(DateTime.local().startOf('week').plus({ days: 4 })),
          new Day(DateTime.local().startOf('week').plus({ days: 5 })),
          new Day(DateTime.local().startOf('week').plus({ days: 6 })),
        ],
        isAvailableWidthReduced: false,
        weekSchedule: new WeekSchedule(),
      };
    },
    watch: {
      daypart(val) {
        // eslint-disable-next-line vue/no-mutating-props
        this.daypart = val;
        this.weekSchedule = WeekSchedule.parse(this.daypart);
      },
    },
    mounted() {
      window.addEventListener('resize', this.checkAvailableWidth);
      GlobalEventBus.$on(GlobalEvents.navbarToggled, this.checkAvailableWidth);
      this.checkAvailableWidth();
      this.weekSchedule = WeekSchedule.parse(this.daypart);
    },
    methods: {
      checkAvailableWidth() {
        const mainContentDiv = window.document.querySelector('.daypart-viewer-container');
        if (mainContentDiv != null) {
          this.isAvailableWidthReduced = mainContentDiv.clientWidth < 900;
        }
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  table {
    th {
      color: var(--textColor);

      padding: 0.1rem;
      text-align: center;
      font-size: 1.3rem;
      font-weight: 400;
    }

    td {
      padding: 0.1rem;

      &.selected {
        background: var(--secondaryColorLight) !important;
      }
    }

    tbody {
      th {
        text-align: left;
        padding-left: 1rem;
        padding-right: 1rem;
      }

      td {
        border-color: #ffffff33;
        position: relative;

        .canvas-cell {
          position: relative;
        }
      }
    }

    thead {
      th {
        padding-left: 0 !important;
        padding-right: 0 !important;
        position: relative;

        sub {
          font-weight: 200;
        }

        .angled-text-container {
          span {
            display: flex;
            flex-direction: column;
            transform: none;

            sub {
              margin-top: 0.3rem;
              margin-bottom: 0.6rem;
            }
          }
        }
      }
    }
  }
</style>
